<template>
  <div>
    <div v-if="isTransparentBgMode" class="transparent-bg-mode-box"></div>
    <div class="bg" :class="{ 'transparent-bg-mode': isTransparentBgMode }">
      <div class="content" ref="content">
        <div
          class="content-box home-content-box"
          :class="{ 'transparent-bg-mode': isTransparentBgMode }"
        >
          <top-header>
            <template #topHeaderTips>
              <div
                v-if="visibleMayiPayDownButton"
                class="top-header-tips"
                @click="visibleMayiPayDown = true"
              >
                お知らせ
              </div>
              <div
                v-if="visiblePnsPayDownButton"
                class="top-header-tips"
                @click="visiblePnsPayDown = true"
              >
                お知らせ
              </div>
              <div
                v-if="visibleMayiKoNoticeButton"
                class="top-header-tips"
                @click="visibleMayiKoNotice = true"
              >
                가격 조정
              </div>
            </template>
          </top-header>
          <switch-version></switch-version>
          <pwa-install
            v-show="!showChannel"
            @isInstallUpdate="isInstallUpdate"
          ></pwa-install>
          <pwa-award v-show="!showChannel" :isInstall="isInstall"></pwa-award>
          <top-banner></top-banner>
          <side-floating-window v-if="isShowBlackFridaySide">
          </side-floating-window>
          <div class="step-box">
            <div class="select-game select-product-box">
              <select-role></select-role>
              <div
                class="vip-head-box"
                v-show="serverId && roleId && showVipHeadBox"
              >
                <div class="vip-head-icon"></div>
                <p class="vip-head-text">{{ letter.vipHeadText }}</p>
                <Button
                  class="vip-head-btn j-get-vip-head-btn"
                  @click="showVipHeadConfirmPopup"
                  :loading="confirmLoading"
                >
                  {{
                    this.isGetVipHead
                      ? letter.vipHeadGotText
                      : letter.vipHeadGetText
                  }}
                </Button>
              </div>
              <link-entry v-if="showLinkEntry"></link-entry>
              <limited-time-activity
                v-if="showLimitedTimeActivity"
                :visibleNoticeButton="visibleKOneDownLimitActivityButton"
                :noticeButtonText="kOneDownLimitActivityButton"
                @showNotice="visibleKOneDownLimitActivity = true"
              ></limited-time-activity>
              <select-product></select-product>
              <select-paytype v-if="showChannel"></select-paytype>
            </div>
          </div>
        </div>
      </div>
      <page-footer-safe v-if="isShowSafe && !isCart && !showChannel" />
      <page-footer v-show="!isCart && !showChannel"></page-footer>
      <service-icon-btn
        v-show="gameId"
        :serverId="pcServerId"
        :roleId="roleId"
        :roleName="roleName"
        :gameId="gameId"
        :isUidLogin="isUidLogin"
        :uid="uid"
        :loginAccount="loginAccount"
      ></service-icon-btn>
      <uid-token-login-popup
        v-bind:visible.sync="visibleTokenLoginPopup"
      ></uid-token-login-popup>
      <transition name="fade" mode="out-in">
        <coupon-list-popup
          v-if="isShowGameCouponPopup"
          popupType="game"
          :enableCouponList="gameCouponEnableList"
          :disableCouponList="gameCouponDisableList"
          :expireCouponList="gameCouponExpireList"
          :activeId="gameActiveCouponId"
          :showItemUseBtn="isShowGameItemUseBtn"
          @closeCouponPopup="hideGameCouponPopup"
        ></coupon-list-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <coupon-activity-popup
          v-if="isShowVaCouponPopup"
          @closeCouponPopup="hideActivityCouponPopup"
        ></coupon-activity-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <coupon-birth-popup
          v-if="isShowBirthCouponPopup"
          @closeCouponPopup="hideBirthCouponPopup"
          :couponList="birthCouponList"
        ></coupon-birth-popup>
      </transition>
      <transition name="fade" mode="out-in">
        <coupon-vip-popup
          v-if="isShowVipCouponPopup"
          @closeCouponPopup="hideVipCouponPopup"
          :couponList="vipCouponList"
        ></coupon-vip-popup>
      </transition>
      <transition name="fade">
        <vip-head-confirm-popup
          v-if="isShowVipHeadConfirmPopup"
          @cancel="isShowVipHeadConfirmPopup = false"
          @confirm="handleConfirmVipHead"
          :languages="letter"
        ></vip-head-confirm-popup>
      </transition>
      <PopupWindow
        v-if="visibleTipPopup"
        type="tips"
        :languages="letter"
        :content="popupTip"
        textAlign="center"
        @onConfirm="visibleTipPopup = false"
        @onCancel="visibleTipPopup = false"
      ></PopupWindow>
      <PopupWindow
        type="tips"
        v-if="visibleRightCenterPopup"
        :confirm="letter.go"
        :languages="letter"
        :content="rightCenterNotice"
        :title="rightCenterNoticeTitle"
        :autoHeight="true"
        :textAlign="+this.gameId === 191 ? 'left' : 'center'"
        @onConfirm="goRightsCenter"
        @onCancel="visibleRightCenterPopup = false"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleRightsNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="pnsRightCenterNoticeTitle"
        :content="pnsRightCenterNotice"
        :autoHeight="true"
        :confirm="letter.v3GoTo"
        @onConfirm="confirmRightsNotice"
        @onCancel="closeRightsNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleCloseCouponSend"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="pnsCloseCouponSendTitle"
        :content="pnsCloseCouponSendContent"
        :autoHeight="true"
        :confirm="letter.v3GoTo"
        @onConfirm="confirmRightsNotice"
        @onCancel="closeCouponSend"
      ></PopupWindow>
      <PopupWindow
        v-if="visiblePayPalNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpPayPalTitle"
        :content="jpPayPalContent"
        :autoHeight="true"
        @onConfirm="closePayPalNotice"
        @onCancel="closePayPalNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleDownJpPayType"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="downJpPayTypeTitle"
        :content="downJpPayTypeContent"
        :autoHeight="true"
        @onConfirm="closeDownJpPayType"
        @onCancel="closeDownJpPayType"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleBankPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="bankPayDownTitle"
        :content="bankPayDownContent"
        :autoHeight="true"
        @onConfirm="closeBankPayDown"
        @onCancel="closeBankPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleMayiPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="mayiPayDownTitle"
        :content="mayiPayDownContent"
        :autoHeight="true"
        @onConfirm="closeMayiPayDown"
        @onCancel="closeMayiPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visiblePnsPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="pnsPayDownTitle"
        :content="pnsPayDownContent"
        :autoHeight="true"
        @onConfirm="closePnsPayDown"
        @onCancel="closePnsPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleKoDzgNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        title=""
        :content="koDzgNoticeContent"
        :autoHeight="true"
        @onConfirm="closeKoDzgNotice"
        @onCancel="closeKoDzgNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleJpGamePayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpDownGame.title"
        :content="jpDownGame.content"
        :autoHeight="true"
        @onConfirm="closeJpGamePayDown"
        @onCancel="closeJpGamePayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visiblePnsPayNoticeDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="pnsNoticeDownTitle"
        :content="pnsNoticeDownContent"
        :autoHeight="true"
        @onConfirm="closePnsPayNoticeDown"
        @onCancel="closePnsPayNoticeDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleDzgJpExtraCoinDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="dzgjpExtraCoinDownTitle"
        :content="dzgjpExtraCoinDownContent"
        :autoHeight="true"
        @onConfirm="closeDzgJpExtraCoinDown"
        @onCancel="closeDzgJpExtraCoinDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleMayiKoNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="mayiKoNoticeTitle"
        :content="mayiKoNoticeContentV1"
        :autoHeight="true"
        @onConfirm="closeMayiKoNotice"
        @onCancel="closeMayiKoNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleMayiPayChangeNotice"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="mayiPayChangeTitle"
        :content="mayiPayChangeContent"
        :autoHeight="true"
        @onConfirm="closeMayiPayChangeNotice"
        @onCancel="closeMayiPayChangeNotice"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleKOneDownLimitActivity"
        type="tips"
        textAlign="left"
        :languages="letter"
        title=""
        :content="kOneDownLimitActivityContent"
        :autoHeight="true"
        @onConfirm="closeKOneDownLimitActivity"
        @onCancel="closeKOneDownLimitActivity"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleKOneDownVip"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="kOneDownVipTitle"
        :content="kOneDownVipContent"
        :autoHeight="true"
        @onConfirm="closeKOneDownVip"
        @onCancel="closeKOneDownVip"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleDzgJpCouponDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="dzgjpCouponDownTitle"
        :content="dzgjpCouponDownContent"
        :autoHeight="true"
        @onConfirm="closeDzgJpCouponDown"
        @onCancel="closeDzgJpCouponDown"
      ></PopupWindow>
      <PopupWindow
        v-if="visibleJpPayDown"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpPayDownTitle"
        :content="jpPayDownContent"
        :autoHeight="true"
        @onConfirm="closeJpPayDown"
        @onCancel="closeJpPayDown"
      ></PopupWindow>
      <PopupWindow
        v-if="isJpLimitPopup"
        type="tips"
        textAlign="left"
        :languages="letter"
        :title="jpLimitPopupTitle"
        :content="jpLimitPopupContent"
        :autoHeight="true"
        :disableClose="true"
        :hideButton="true"
        style="z-index: 1001"
      ></PopupWindow>
      <transition name="fade" mode="out-in">
        <Loading v-show="loading"></Loading>
      </transition>
      <theme-config v-if="showThemeConfig"></theme-config>
      <black-friday-popup></black-friday-popup>
    </div>
  </div>
</template>

<script>
import PwaInstall from '@components/officialStore/PwaInstall.vue';
import PwaAward from '@components/officialStore/PwaAward.vue';
import TopBanner from '@components/officialStore/TopBanner.vue';
import TopHeader from '@components/officialStore/TopHeader.vue';
import SelectProduct from '@components/officialStore/product/SelectProduct.vue';
import ServiceIconBtn from '@components/officialStore/ServiceIcon.vue';
import SelectPaytype from '@components/officialStore/paytype/SelectPaytype.vue';
import PageFooterSafe from '@components/officialStore/PageFooterSafe.vue';
import PageFooter from '@components/officialStore/PageFooter.vue';
import CouponListPopup from '@components/officialStore/coupon/CouponListPopup.vue';
import CouponVipPopup from '@components/officialStore/coupon/CouponVipPopup.vue';
import CouponBirthPopup from '@components/officialStore/coupon/CouponBirthPopup.vue';
import CouponActivityPopup from '@components/officialStore/coupon/CouponActivityPopup.vue';
import VipHeadConfirmPopup from '@components/officialStore/VipHeadConfirmPopup.vue';
import SelectRole from '@components/officialStore/login/SelectRole.vue';
import Loading from '@components/officialStore/Loading.vue';
import UidTokenLoginPopup from '@components/officialStore/login/UidTokenLoginPopup.vue';
import coupon from '@mixins/officialStore/coupon';
import pwa from '@mixins/officialStore/pwa';
import allStorePopup from '@mixins/allStorePopup';
import LinkEntry from '@components/officialStore/LinkEntry.vue';
import SideFloatingWindow from '@components/officialStore/activity/SideFloatingWindow.vue';
import BlackFridayPopup from '@components/officialStore/activity/BlackFridayPopup.vue';
import LimitedTimeActivity from '@components/officialStore/activity/LimitedTimeActivity.vue';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV1';
import {
  UPDATE_VISIBLE_TOKEN_LOGIN_POPUP,
  UPDATE_VIP_HEAD_STATE,
  GET_VIP_HEAD
} from '@store/officialStore';
import { mapGetters, mapState } from 'vuex';
import gameInfoConfig from '@configs/officialStore/globalGameInfoConfig';
import globalConfig from '@utiles/officialStore/globalConfig';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import languages from '@store/languages/index';
import openActivity, { NOTICE_POPUP_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
import SwitchVersion from '@components/officialStore/SwitchVersion.vue';
import transparentBg from '@mixins/officialStore/transparentBg';
import jpLimitPopup from '@mixins/jpLimitPopup';
export default {
  name: 'webStorePage',
  mixins: [coupon, pwa, allStorePopup, transparentBg, jpLimitPopup],
  data() {
    return {
      confirmLoading: false,
      isShowVipHeadConfirmPopup: false,
      isGetVipHead: false,
      visibleTipPopup: false,
      visibleRightCenterPopup: false, // 权益中心弹窗
      popupTip: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      loading: state => state.loading,
      showChannel: state => state.showChannel,
      letter: state => state.letter,
      serverList: state => state.serverList,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      loginAccount: state => state.login.loginAccount,
      uid: state => state.login.uid,
      isUidLogin: state => state.login.isUidLogin,
      serverId: state => state.serverId,
      roleId: state => state.roleId,
      isCart: state => state.cart.isCart,
      showThemeConfig: state => state.showThemeConfig,
      isLogin: state => state.login.isLogin,
      showVipHeadBox: state => state.showVipHeadBox,
      showCurrency: state => state.showCurrency
    }),
    ...mapGetters([
      'gameInfoConfig',
      'showRightsCenter',
      'showRightCenterPopup',
      'vaCouponConfig'
    ]),
    isShowVaCouponPopup() {
      return this.isLogin && this.vaCouponConfig?.isOpen;
    },
    showLinkEntry() {
      if (
        +this.gameId === 191 &&
        (this.lang === 'zh-TW' || this.lang === 'ja-JP')
      ) {
        return true;
      }
      return (
        this.gameInfoConfig?.linkEntry &&
        (this.gameInfoConfig?.linkEntry?.link ||
          this.gameInfoConfig?.linkEntry?.leftLink ||
          this.gameInfoConfig?.linkEntry?.rightLink)
      );
    },
    //黑五侧边栏
    isShowBlackFridaySide() {
      return this.gameInfoConfig?.isBlackFridayVersion;
    },
    visibleTokenLoginPopup: {
      get() {
        return this.$store.state.visibleTokenLoginPopup;
      },
      set(val) {
        this.$store.commit(UPDATE_VISIBLE_TOKEN_LOGIN_POPUP, val);
      }
    },
    // 支付安全展示
    isShowSafe() {
      return !!gameInfoConfig[this.gameId]?.isShowSafe;
    },
    gamePrefix() {
      return this.$store.getters.gameInfoConfig.gameCode;
    },
    showLimitedTimeActivity() {
      return (
        this.gameInfoConfig?.limitedTimeActivity.isOpen &&
        this.showCurrency &&
        !this.showChannel
      );
    },
    offLineNotice() {
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    },
    rightsOnlineNotice() {
      return (
        this.letter.rightsIntro ||
        this.getSpecifyLang('ja-JP', 'rightsIntro') ||
        ''
      );
    },
    rightCenterNoticeTitle() {
      // 2025.05.27 PNS支付页优惠劵下架公告特殊处理
      if (+this.gameId === 191) {
        return this.letter.rightCenterNoticeTitle;
      }
      return this.letter.notice;
    },
    rightCenterNotice() {
      // if (this.showRightsCenter) {
      //   return this.rightsOnlineNotice
      // }
      // 2025.05.27 PNS支付页优惠劵下架公告特殊处理
      if (+this.gameId === 191) {
        return this.letter.rightCenterNoticeContent;
      }
      // 韩国大掌柜权益中心弹窗公告文案更新
      if (+this.gameId === 211) {
        return '할인 쿠폰은 프리미엄센터(대회원센터)- 포인트 상점에서 교환하시기 바랍니다.';
      }
      return this.offLineNotice;
    }
  },
  watch: {
    showChannel(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const ele = document.getElementById('j-paytype-title');
          ele && ele.scrollIntoView();
        });
      }
    },
    isLogin(newVal) {
      if (newVal) {
        this.updateVipHeadBoxState();
        this.checkShowRightCenterPopup();
      }
    },
    isTransparentBgMode: {
      handler(newVal) {
        if (newVal) {
          document.querySelector('html')?.classList.add('transparent-bg-mode');
          document.querySelector('body')?.classList.add('transparent-bg-mode');
        } else {
          document
            .querySelector('html')
            ?.classList.remove('transparent-bg-mode');
          document
            .querySelector('body')
            ?.classList.remove('transparent-bg-mode');
        }
      },
      immediate: true
    }
  },
  methods: {
    showVipHeadConfirmPopup() {
      if (!this.isGetVipHead) {
        this.isShowVipHeadConfirmPopup = true;
      }
    },
    getVipHead() {
      this.confirmLoading = true;
      this.$store
        .dispatch(GET_VIP_HEAD, {
          game_id: this.gameId,
          server_id: this.serverId,
          role_id: this.roleId
        })
        .then(res => {
          this.confirmLoading = false;
          if (res.result && parseInt(res.result) === 1) {
            this.isGetVipHead = true;
          } else {
            this.popupTip = this.letter.vipHeadGetErrTip1;
            this.visibleTipPopup = true;
          }
        })
        .catch(_err => {
          this.confirmLoading = false;
          //错误弹窗
          this.popupTip = this.letter.vipHeadGetErrTip1;
          this.visibleTipPopup = true;
        });
    },
    handleConfirmVipHead() {
      this.isShowVipHeadConfirmPopup = false;
      this.getVipHead();
    },
    updateVipHeadBoxState() {
      // 2023.4.19 需求人：邓智轩 PNS支付页新增VIP头像框奖励领取
      // 2025.1.24 需求人：徐奇铭 K1支付页新增VIP头像框奖励领取
      const openVipHeadGameList = [191, 285];
      if (
        openVipHeadGameList.includes(+this.gameId) &&
        this.isLogin &&
        !this.isUidLogin
      ) {
        this.$store.dispatch(UPDATE_VIP_HEAD_STATE, {
          gameId: this.gameId
        });
      }
    },
    goRightsCenter() {
      clickButton({
        btnName: 'go_right_center',
        locationKey: this.$route.meta.pageName,
        otherParams: {
          link: this.gameInfoConfig?.rightsCenterLink,
          name: 'rightCenterPage'
        }
      });
      let jumpLink = '';
      if (this.gameInfoConfig?.isOnlineRightsCenter && this.showRightsCenter) {
        jumpLink = this.gameInfoConfig?.preRightsPopupLink
          ? this.gameInfoConfig?.preRightsPopupLink
          : this.gameInfoConfig?.rightsCenterLink;
        openActivity(NOTICE_POPUP_ACTIVITY, jumpLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
      } else {
        // 获取当前的链接
        jumpLink = window.location.href + 'vip_score';
        sdkOpenLink({
          link: jumpLink
        });
      }
      this.visibleRightCenterPopup = false;
    },
    getSpecifyLang(lang, key) {
      return languages.getSpecifyLang(lang, key);
    },
    checkShowRightCenterPopup() {
      if (!this.showRightCenterPopup) {
        return;
      }
      let RIGHT_CENTER_POPUP_STATE = 'RIGHT_CENTER_POPUP_STATE' + this.gameId;
      if (+this.gameId === 213) {
        RIGHT_CENTER_POPUP_STATE += this.loginAccount;
      }
      // console.log(RIGHT_CENTER_POPUP_STATE, this.loginAccount)
      if (!+globalConfig.getCookie(RIGHT_CENTER_POPUP_STATE)) {
        showPopup(popupType.rightCenterPopup);
        this.visibleRightCenterPopup = true;
        // 3s后设置cookie, 避免刷新误触发
        setTimeout(() => {
          globalConfig.setCookie(RIGHT_CENTER_POPUP_STATE, 1);
        }, 3000);
      }
    }
  },
  mounted() {
    // 2024.07.03 邓智轩：日本大掌柜209-首次访问支付页弹出权益中心弹窗
    // 2024.08.08 将权益中心弹窗是否展示封装为按配置进行展示的方式
    // 2024.08.19 全球大掌柜是否弹出与游戏账号相关
    if (!(+this.gameId === 213 && !this.loginAccount)) {
      this.checkShowRightCenterPopup();
    }

    // 权益中心打开时带有showCoupon=1参数直接展示优惠券
    globalConfig.getHrefParam('showCoupon') === '1' &&
      this.showGameCouponPopup();
  },
  components: {
    PageFooterSafe,
    TopBanner,
    TopHeader,
    SelectProduct,
    ServiceIconBtn,
    PageFooter,
    CouponListPopup,
    CouponVipPopup,
    CouponBirthPopup,
    CouponActivityPopup,
    VipHeadConfirmPopup,
    SelectPaytype,
    SelectRole,
    Loading,
    UidTokenLoginPopup,
    ThemeConfig: () => import('@components/officialStore/ThemeConfig.vue'),
    LinkEntry,
    PwaInstall,
    PwaAward,
    SideFloatingWindow,
    BlackFridayPopup,
    LimitedTimeActivity,
    SwitchVersion
  }
};
</script>
<style lang="scss">
.home-content-box.transparent-bg-mode {
  .top-header,
  .pwaInstall-box,
  .banner,
  .choose-role-title,
  .choose-box,
  .switch-version-btn,
  .share-page-btn,
  .choose-product-title {
    display: none;
  }
  .has-choose-product {
    margin-top: 30px;
  }
}
</style>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';

.bg {
  display: block;
  float: left;
  width: 100%;
  text-align: center;
  position: relative;
  background-position: top center;
  background-color: #111114;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  min-height: 100%;
  @psetbg ("bg.png", false, false);
}
.bg.transparent-bg-mode {
  height: calc(100vh - 250px);
  overflow-y: scroll;
}

.content {
  position: relative;
  margin-bottom: 215px;
}

.content-box {
  position: relative;
  font-size: 0;
  padding-top: 1px;
}

.step-box {
  position: relative;
  text-align: left;
  transition: all 0.6s;
  box-sizing: border-box;
}

@media screen and (orientation: landscape) {
  .step-box {
    width: 1202px;
    margin: 0 auto;
    padding: 0;
  }

  .bg {
    background-size: cover;
    background-repeat: repeat-y !important;
    @psetbg ("bg-hen.png", false, false);
  }
}
.transparent-bg-mode-box {
  height: 250px;
  width: 100%;
  background-color: transparent;
}
</style>

<style lang="scss">
html.transparent-bg-mode {
  background-color: transparent !important;
}
body.transparent-bg-mode {
  background-color: transparent !important;
}
</style>
